import React from 'react';
import { Check, Info, Lock } from 'lucide-react';
import { PRICING_PLANS } from '../constants';
import { Link } from 'react-router-dom';

const PricingPage: React.FC = () => {
  return (
    <div className="pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">Investasi Kecil, Kebebasan Besar</h1>
          <p className="text-slate-600">Pilih paket yang sesuai dengan kebutuhan absensi Anda.</p>
        </div>

        {/* Policy Alert Banner */}
        <div className="max-w-4xl mx-auto mb-12 bg-orange-50 border border-orange-200 rounded-xl p-4 flex items-start gap-3">
            <div className="bg-orange-100 p-2 rounded-lg text-orange-600">
                <Lock className="h-5 w-5" />
            </div>
            <div>
                {/* Changed h4 to h2 to fix Accessibility Heading Order */}
                <h2 className="font-bold text-orange-900 text-sm mb-1">Kebijakan Pemakaian Perangkat</h2>
                <p className="text-orange-800 text-xs leading-relaxed">
                    Demi keamanan akun Anda dan mencegah deteksi kecurangan, satu lisensi aktif hanya berlaku untuk <strong>1 Perangkat (Device ID)</strong> dan <strong>1 Aplikasi Target</strong> secara bersamaan. Login di perangkat baru akan mereset lisensi perangkat lama.
                </p>
            </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {PRICING_PLANS.map((plan) => (
            <div 
              key={plan.id} 
              className={`relative flex flex-col p-8 rounded-3xl border transition-all ${
                plan.recommended 
                  ? 'bg-white border-brand-primary shadow-2xl scale-105 z-10 ring-4 ring-orange-50' 
                  : 'bg-white border-slate-200 hover:border-brand-primary/30 shadow-sm'
              }`}
            >
              {plan.recommended && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-primary text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wider shadow-md">
                  Paling Populer
                </div>
              )}

              <div className="mb-8">
                <h3 className="text-xl font-bold text-slate-900 mb-2">{plan.name}</h3>
                <div className="flex items-baseline">
                  <span className="text-4xl font-bold text-slate-900">{plan.price}</span>
                  <span className="text-slate-600 ml-2">/{plan.duration}</span>
                </div>
                <p className="text-sm text-slate-600 mt-4">{plan.description}</p>
              </div>

              <ul className="flex-1 space-y-4 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <Check className="h-5 w-5 text-brand-primary flex-shrink-0 mr-3" />
                    <span className="text-slate-600 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link 
                to="/hubungi-kami"
                className={`w-full py-4 rounded-xl font-bold text-center transition-all ${
                  plan.recommended
                    ? 'bg-brand-primary hover:bg-orange-600 text-white shadow-lg shadow-orange-500/30'
                    : 'bg-slate-100 hover:bg-slate-200 text-slate-700'
                }`}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-50 border border-blue-100 rounded-xl p-6 flex items-start gap-4 shadow-sm">
          <Info className="h-6 w-6 text-blue-500 flex-shrink-0 mt-1" />
          <div>
            <h4 className="text-lg font-semibold text-slate-900 mb-2">Garansi Uang Kembali</h4>
            <p className="text-slate-600 text-sm">
              Jika XCape tidak bekerja pada aplikasi target Anda dalam 3 hari masa uji coba, kami tidak akan menagih sepeserpun. Pembayaran hanya diproses setelah Anda puas.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;